import { useMsal } from '@azure/msal-react';
import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import React from 'react';

interface PropType {
    component: React.FC<any>;
    headerMarginTop: number;
}

const PrivateRoute: FC<PropType> = ({ component: Component ,headerMarginTop }) => {
    const {accounts}=useMsal();
    if (accounts.length>0) return <Component headerMarginTop={headerMarginTop} />;
    return <Navigate to={'/'} />
};

export default PrivateRoute;